import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import Company from "components/client-search/Company";

import styles from "./CompanySearchResults.m.scss";

function CompanySearchResults(props) {
  const { theme, data, workWithClient } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.header)}>
        <div>{"Id"}</div>
        <div>{"Краткое наименование"}</div>
        <div>{"Полное наименование"}</div>
        <div className={classnames(theme.controls)} />
      </div>
      {data && data.companies
        ? data.companies.map((company, index) => {
            return (
              <Company
                key={index}
                client={company}
                workWithClient={workWithClient}
                theme={{ wrapper: theme.item }}
              />
            );
          })
        : null}
    </div>
  );
}

CompanySearchResults.displayName = "CompanySearchResults";

CompanySearchResults.propTypes = {
  theme: PropTypes.object,
  data: PropTypes.object,
  workWithClient: PropTypes.func.isRequired,
};

CompanySearchResults.defaultProps = {};

export default themr("@lifepay/CompanySearchResults", styles)(CompanySearchResults);



// WEBPACK FOOTER //
// ./src/components/client-search/CompanySearchResults/CompanySearchResults.js